export default "__VITE_ASSET__BOR3FWtd__"